import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/*
Перебирает тело запроса и проверяет, что ни одно поле не является undefined
*/
@Injectable()
export class CheckForUndefinedFieldsInterceptor implements HttpInterceptor {
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!ETR.isProduction && !!request.body) {
            this.validateAllPropertiesAreNotUndefined(request.body);
        }
        return next.handle(request);
    }
    private validateAllPropertiesAreNotUndefined(input: any): any {
        Object.keys(input).forEach(name => {
            const value = input[name];
            if (typeof value === 'undefined') {
                throw new Error(
                    `Свойство ${name} имеет значение undefined. При отправке на сервер запроса все параметры должны быть указаны явно и для пустого значения необходимо использовать null.`
                );
            } else if (value === null) {
                return;
            } else if (Array.isArray(value)) {
                value.forEach(item => {
                    this.validateAllPropertiesAreNotUndefined(item);
                });
            } else if (typeof value === 'object') {
                this.validateAllPropertiesAreNotUndefined(value);
            }
        });
    }
}
